import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.medicine': {
         extendedDosage: {
            administrationIntervalMap: {
               /* eslint-disable sort-keys-fix/sort-keys-fix */
               1: 'codziennie',
               2: 'co 2 dni',
               3: 'co 3 dni',
               4: 'co 4 dni',
               5: 'co 5 dni',
               6: 'co 6 dni',
               7: 'co 7 dni',
               /* eslint-enable sort-keys-fix/sort-keys-fix */
            },
            breakSummary: 'Przerwa przez {{duration}}',
            frequencyCycleSummary: '{{portion}}x{{interval}} przez {{duration}}',
            frequencyCycleSummaryWithUnit: '{{portion}} {{unit}} co {{interval}} przez {{duration}}',
            timeUnitMap: {
               /* eslint-disable sort-keys-fix/sort-keys-fix */
               HOUR: { accusative: 'godzinę', genitive: 'godziny', plural: 'godzin' },
               DAY: { accusative: 'dzień', genitive: 'dni', plural: 'dni' },
               WEEK: { accusative: 'tydzień', genitive: 'tygodnie', plural: 'tygodni' },
               MONTH: { accusative: 'miesiąc', genitive: 'miesiące', plural: 'miesięcy' },
               /* eslint-enable sort-keys-fix/sort-keys-fix */
            },
            timeUnitShortMap: {
               /* eslint-disable sort-keys-fix/sort-keys-fix */
               HOUR: 'godz.',
               DAY: 'dni',
               WEEK: 'tyg.',
               MONTH: 'mies.',
               /* eslint-enable sort-keys-fix/sort-keys-fix */
            },
            timesOfDayCycleSummary: '{{schema}} {{administration}} przez {{duration}}',
         },
         medicine: {
            RPW: 'RPW',
            addMedicineToPrescription: 'Dodaj lek do eRecepty',
            anxiolytic: 'Anksjolityk',
            continuouslyUsedMedicine: {
               addMedicineToContinuouslyUsedMedicines: 'Dodaj lek do leków stałych',
               cannotAddWithdrawnMedicineToContinuouslyUsedMedicines:
                  'Nie można dodać wycofanego leku do leków stałych',
               deleteConfirmationModal: {
                  cancel: 'Anuluj',
                  confirm: 'Zatwierdź',
                  content: 'Czy na pewno usunąć {{medicineName}} z listy leków stałych?',
                  title: 'Usuwasz lek stały',
               },
               removeMedicineFromContinuouslyUsedMedicines: 'Usuń lek z leków stałych',
               successfullyCreatedContinuouslyUsedMedicine: 'Dodano lek do listy leków stałych.',
               successfullyDeletedContinuouslyUsedMedicine: 'Usunięto lek z listy leków stałych.',
            },
            details: {
               addToPrescription: 'Dodaj do eRecepty',
               additionalInformationAccordion: {
                  address: 'Adres',
                  atcCodes: 'Kody ATC',
                  distributor: 'Dystrybutor',
                  eanCode: 'Kod EAN',
                  email: 'Adres e-mail',
                  faxNumber: 'Fax',
                  manufacturer: 'Producent',
                  phoneNumber: 'Numer telefonu',
                  prescriptionType: 'Typ recepty',
                  prescriptionTypeDescription: 'Opis typu recepty',
                  productType: 'Typ produktu',
                  registrationCertificateNumber: 'Numer świadectwa rejestracji (polski lub UE)',
                  therapeuticClass: 'Klasa terapeutyczna',
                  websiteAddress: 'Strona internetowa',
               },
               loadingMedicineDescription: 'Ładowanie opisu leku',
               medicineDescription: 'Opis leku',
               section: {
                  additionalMedicineInformation: 'Dodatkowe informacje',
                  composition: 'Skład',
                  contraindications: 'Przeciwwskazania',
                  dosage: 'Dawkowanie',
                  effects: 'Działanie',
                  indications: 'Wskazania z CHPL',
                  interactions: 'Interakcje',
                  notes: 'Uwagi',
                  pregnancyAndLactationInfo: 'Ciąża i karmienie piersią',
                  reimbursements: 'Refundacja',
                  sideEffects: 'Działania niepożądane',
                  warnings: 'Środki ostrożności',
               },
            },
            showMedicineDetails: 'Pokaż opis leku',
         },
         medicineWithdrawn: 'Lek wycofany',
         prescription: {
            prescriptionUnavailability: {
               S_AND_DZ_UNAVAILABLE_FOR_PRIVATE_HEALTHCARE_PROVIDERS:
                  'Preskrypcja leku z uprawnieniem S lub DZ możliwa wyłącznie w przypadku udzielenia świadczenia w ramach umowy z NFZ',
            },
         },
         reimbursementIndications: 'Wskazania refundacyjne:',
         safetyIndicators: {
            applyingAllowed: 'Stosowanie dopuszczone',
            breastFeeding: 'Karmienie piersią',
            couldNotResolveCategory: 'nie możemy ustalić kategorii bezpieczeństwa',
            couldNotResolveCategoryForName: 'Nie możemy ustalić kategorii bezpieczeństwa - {{name}}',
            drivingCar: 'Prowadzenie pojazdu',
            drivingCarSafe: 'Nie wpływa na sprawność psychomotoryczną i prowadzenie pojazdów',
            influenceOn: 'Wpływ na: {{interactionTarget}}',
            interactionWithAlcohol: 'Interakcja z alkoholem',
            noAlcoholInteraction: 'Brak stwierdzonej interakcji',
            noData: 'Brak danych',
            pregnantFirstTrimester: 'Pierwszy trymestr',
            pregnantSecondTrimester: 'Drugi trymestr',
            pregnantThirdTrimester: 'Trzeci trymestr',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.medicine');
